import React from "react";
import { ourServices } from "../data/data";
import Person from "../components/svgComponent/Person";
import Expert from "../components/svgComponent/Expert";
import Trial from "../components/svgComponent/Trial";
import Time from "../components/svgComponent/Time";
import Progress from "../components/svgComponent/Progress";
import Focus from "../components/svgComponent/Focus";
import Wifi from "../components/svgComponent/Wifi";
import Growth from "../components/svgComponent/Growth";
import Creative from "../components/svgComponent/Creative";
import Currency from "../components/svgComponent/Currency";

const Services = () => {
  return (
    <>
      <section id="services" className="container-services">
        <div className="section-width">
          <div className="section-title-wrapper">
            <h5 className="section-title text-center">Features & Services</h5>
          </div>
          <div className="section-content-wrapper">
            <div className="card card--services">
              <Person className="card--services__icon" />
              <p className="card-text card-text--services">
                One-on-one personalized home tutoring for all grades.
              </p>
            </div>

            <div className="card card--services">
              <Expert className="card--services__icon" />
              <p className="card-text card-text--services">
                Expert tutors for CBSE, ICSE, and State Boards.
              </p>
            </div>

            <div className="card card--services">
              <Trial className="card--services__icon" />
              <p className="card-text card-text--services">
                Free trial class to assess teaching quality.
              </p>
            </div>

            <div className="card card--services">
              <Time className="card--services__icon" />
              <p className="card-text card-text--services">
                Flexible class timings to suit your schedule.
              </p>
            </div>

            <div className="card card--services">
              <Progress className="card--services__icon" />
              <p className="card-text card-text--services">
                Regular progress updates and student assessments.
              </p>
            </div>

            <div className="card card--services">
              <Focus className="card--services__icon" />
              <p className="card-text card-text--services">
                Special focus on weak subjects and exam preparation.
              </p>
            </div>

            <div className="card card--services">
              <Currency className="card--services__icon" />
              <p className="card-text card-text--services">
                Affordable fees with no hidden charges.
              </p>
            </div>

            <div className="card card--services">
              <Wifi className="card--services__icon" />
              <p className="card-text card-text--services">
                Both in-person and online classes available.
              </p>
            </div>

            <div className="card card--services">
              <Growth className="card--services__icon" />
              <p className="card-text card-text--services">
                Trusted by parents for consistent academic growth
              </p>
            </div>

            <div className="card card--services">
              <Creative className="card--services__icon" />
              <p className="card-text card-text--services">
                Concept-based teaching with doubt-clearing sessions.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Services;
